import { consts } from './drawLinesOnCanvas';
import { Point } from 'logic/reports/doLinesIntersect';
import { DrawData } from 'ui/shared/calculateDrawData';

export type HitTestResult = number | null;

export const hitTestLines = (x: number, y: number, canvas: HTMLCanvasElement, drawData: DrawData, points: ReadonlyArray<Point>): HitTestResult => {
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        return null;
    }
    ctx.save();

    const offset = (consts.dragHandleSize - 1) / 2;

    // Test the drag handles
    const result = points.map((pt, i) => {
        ctx.beginPath();
        ctx.rect(pt.x - offset, pt.y - offset, consts.dragHandleSize, consts.dragHandleSize);
        if (ctx.isPointInPath(x, y)) {
            return i;
        }
        return null;
    }).filter(ht => typeof ht === 'number').shift();

    ctx.restore();

    return typeof result === 'number' ? result : null;
};



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/line/hitTestLines.ts